
import { Component, Vue } from 'vue-property-decorator';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import { TranslateResult } from 'vue-i18n';

@Component({
  components: {
    LanguageSwitcher,
  },
})
export default class Navbar extends Vue {
  get navLinks(): {
    routeName: string;
    name: TranslateResult;
    icon: string;
  }[] {
    return [
      {
        routeName: 'Context',
        name: this.$t('navbar.context'),
        icon: '$vuetify.icons.Cog',
      },
      {
        routeName: 'Map',
        name: this.$t('navbar.map'),
        icon: '$vuetify.icons.Map',
      },
      {
        routeName: 'Tools',
        name: this.$t('navbar.tools'),
        icon: 'mdi-wrench-clock',
      },
      {
        routeName: 'Solutions',
        name: this.$t('navbar.solutions'),
        icon: '$vuetify.icons.LightBulb',
      },
    ];
  }
}
